export default __webpack_public_path__ + "/dist/images/image11.7a6d4213b80c99e028b1d57e758ced00.jpg";